// src/components/SegmentTimerWithProgress.js
import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import CountdownTimer from './CountdownTimer'; // Reuse the text timer

// --- ADDED: serverTimeOffset prop ---
export default function SegmentTimerWithProgress({ endTime, duration, sx = {}, serverTimeOffset = 0 }) {
  const [timeLeft, setTimeLeft] = useState(0); // Initialize to 0
  const [progress, setProgress] = useState(0); // Initialize to 0

  useEffect(() => {
    // Function to calculate remaining time using offset
    const calculateRemaining = () => {
        if (!endTime) return 0;
        // Use estimated server time
        const estimatedServerNow = Date.now() + serverTimeOffset;
        return Math.max(0, endTime - estimatedServerNow);
    };

    // Set initial time and progress immediately using the offset
    const initialRemaining = calculateRemaining();
    setTimeLeft(initialRemaining);
    // Ensure progress calculation handles duration correctly, even if initialRemaining is 0
    setProgress(duration > 0 ? (initialRemaining / duration) * 100 : (initialRemaining > 0 ? 100 : 0));

    // Only start interval if there's an end time and it's in the future (based on estimated server time)
    if (endTime && initialRemaining > 0) {
        const interval = setInterval(() => {
            const remaining = calculateRemaining();
            setTimeLeft(remaining);
            // Calculate progress based on original duration and remaining time
            setProgress(duration > 0 ? (remaining / duration) * 100 : 0);

            if (remaining === 0) {
                clearInterval(interval); // Stop interval when time is up
            }
        }, 500); // Update twice a second

        // Cleanup interval
        return () => clearInterval(interval);
    } else {
         // Ensure time and progress are 0 if endTime is invalid or past
        setTimeLeft(0);
        setProgress(0);
    }
    // --- ADDED: serverTimeOffset dependency ---
  }, [endTime, duration, serverTimeOffset]);

  // Determine color based on time left
  const color = timeLeft === 0 ? 'error'
              : timeLeft < 10000 ? 'warning' // Use theme warning color for last 10 seconds
              : 'primary'; // Default primary color for the bar

  return (
    <Box sx={{ width: '100%', ...sx }}>
      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}>
         {/* --- Pass serverTimeOffset down --- */}
         <CountdownTimer endTime={endTime} variant="h5" serverTimeOffset={serverTimeOffset} />
      </Box>
      <LinearProgress
        variant="determinate"
        value={progress}
        color={color} // Use dynamic color
        sx={{ height: 10, borderRadius: 5 }} // Make the bar thicker and rounded
      />
    </Box>
  );
}
